module.exports = __webpack_public_path__ + "img/header-img.4122040c.png";